<template>
	<a-card :body-style="{padding: '24px 32px'}" :bordered="false">
		<a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
			<a-form-model-item>
				<company-search
					v-model="search.company"
					placeholder="请选择所属公司"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-range-picker v-model="range"  valueFormat="YYYY-MM-DD" />
			</a-form-model-item>
			<a-form-model-item>
				<a-button
					type="primary"
					html-type="submit"
					icon="search"
				>
					查询
				</a-button>
			</a-form-model-item>
		</a-form-model>
		<a-divider />
		<a-table
        :pagination="pager"
        @change="change"
        :columns="columns"
        :data-source="list"
		rowKey="_id"
        bordered>
			<template slot="pk" slot-scope="pk, record">
				<div>派件入站：{{ record.inboundnum }}</div>
				<div>派件出站：{{ record.outboundnum }}</div>
				<div>出站率：{{ record.outboundRate | toPercent }}</div>
			</template>
			<template slot="profit" slot-scope="pk, record">
				<div>派件收益：{{ record.profit }}</div>
				<div>超时收费：{{ record.overTimeFee }}</div>
			</template>
			<template slot="cab" slot-scope="pk, record">
				<div>柜子总数：{{ record.cabinetTotal }}</div>
				<div>可用数：{{ record.availableCabNum }}</div>
				<div>故障数：{{ record.faultCabNum }}</div>
				<div>周转率：{{ record.cabUseRate | toPercent }}</div>
			</template>
			<template slot="notice" slot-scope="pk, record">
				<div>短信数：{{ record.smsnum }}</div>
				<div>微信数：{{ record.wechatnum }}</div>
				<div>微信率：{{ record.wechatRate | toPercent}}</div>
			</template>
<!--			<template slot="title" slot-scope="currentPageData">-->
<!--				Header{{ currentPageData }}-->
<!--			</template>-->
<!--			<template slot="footer" slot-scope="currentPageData">-->
<!--				Footer-->
<!--			</template>-->
		</a-table>
	</a-card>
</template>

<script>
import { companydailyreport } from '@/api/company';

export default {
  name: 'dialyreport',
  data() {
  	return {
	    list: [],
      pager: {},
	    search: {},
      range: [],
	    loading: false,
	  };
  },
  created() {
  	this.getList();
  },
  computed: {
	  columns() {
	    const isAdmin = this.$store.getters.isSuperAdmin;
      const col = [
	      {
		      title: '#',
		      dataIndex: 'index',
		      customRender: (text, row, index) => index + 1,
		      key: 'index',
		      width: '50px',
	      },
        {
          title: '公司名称',
          dataIndex: 'company.name',
        },
        {
          title: '日期',
          dataIndex: 'day',
        },
	      {
		      title: '收益',
		      dataIndex: 'profit',
	        scopedSlots: { customRender: 'profit' },
	      },
	      {
		      title: '派件信息',
		      dataIndex: 'inboundnum',
	        scopedSlots: { customRender: 'pk' },
	      },
	      {
		      title: '柜子信息',
		      dataIndex: 'cabinetTotal',
		      scopedSlots: { customRender: 'cab' },
	      },
	      {
		      title: '通知',
		      dataIndex: 'smsnum',
		      scopedSlots: { customRender: 'notice' },
	      },
      ];
      const item = {
        title: '系统收益',
        dataIndex: 'companyprofit',
      };
      if (isAdmin) {
        col.splice(4, 0, item);
      }
      return col;
	  },
  },
  methods: {
  	async getList() {
  		this.loading = true;
      this.search.dayStart = this.range[0];
      this.search.dayEnd = this.range[1];
  		try {
        const { data: { docs, pager } } = await companydailyreport(this.search);
        this.list = docs;
        this.pager = {
          ...pager,
          showTotal: (total) => `共计 ${total} 条信息`,
        };
	    } catch (e) {
				  console.error(e);
	    }
	    this.loading = true;
	  },
	  handleSearch() {
      this.search.page = 1;
  		this.getList();
	  },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
  },
};
</script>

<style scoped>

</style>
